import PrelevementsController from './prelevements.controller';

export default {
    controller: PrelevementsController,
    template: require('./prelevements.html')
};
